import Setup from './Setup';
import SetupFooter from './SetupFooter';

export { Setup, SetupFooter };
